import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RiderHistoryComponent } from './rider-history.component';
import {RiderService} from '../rider.service';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {AgGridModule} from 'ag-grid-angular';
import {FormsModule} from '@angular/forms';
import {GridComponentsModule} from '../../A2-utils/grid-components/grid-components.module';
import {ViewAttachmentFileComponent} from '../../A2-utils/grid-components/view-attachment-file/view-attachment-file.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Trip2ThemeModule,
    AgGridModule.withComponents([
      ViewAttachmentFileComponent
    ]),
    GridComponentsModule
  ],
  declarations: [RiderHistoryComponent],
  exports: [RiderHistoryComponent],
  providers: [RiderService]
})
export class RiderHistoryModule { }



// WEBPACK FOOTER //
// ./src/app/pages/riders/rider-history/rider-history.module.ts